//
// Module for the EDM Document Workflow Associations Index view
//
rs.module("workflow/configuration/edmworkflowassociations/index",

    ["controls/data/grid"],

    function (gridModule) {

        // Initialize the module
        function initialize(lrsGridApi, jsSelectors, ajaxUrls) {

            var filter = $.js(jsSelectors.filter);
            var edmDocumentSelect = filter.js(jsSelectors.edmDocumentSelect);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);
            var addButton = $.js(jsSelectors.addButton);

            // Register edmDocumentSelect changed event
            edmDocumentSelect.change(edmDocumentChanged);

            // Handle dynamic display of grid data on edmDocumentSelect changed
            function edmDocumentChanged() {

                loadingSpinner.show();

                gridModule.update(
                    ajaxUrls.getGridData,
                    { edmDocumentInfoKey: edmDocumentSelect.val() },
                    lrsGridApi.agGridApi,
                    function done(gridUpdate) {
                        loadingSpinner.hide();

                        // Update the Add button url which includes the selected edmDocument
                        addButton.attr('href', gridUpdate.context.addUrl);
                    }
                );
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);